const ALLOWED_TAGS = new Set([
  'P', 'DIV', 'BR', 'STRONG', 'B', 'EM', 'I', 'U', 'S', 'H1', 'H2', 'H3',
  'UL', 'OL', 'LI', 'BLOCKQUOTE', 'SPAN', 'MARK', 'A', 'HR', 'CODE', 'PRE', 'IMG',
  'TABLE', 'THEAD', 'TBODY', 'TR', 'TD', 'TH',
])
const ALLOWED_STYLES = new Set(['color', 'background-color', 'font-size', 'text-align'])

export function sanitizeRichTextClient(html: string) {
  if (typeof DOMParser === 'undefined') return html.replace(/<script[\s\S]*?<\/script>/gi, '')
  const document = new DOMParser().parseFromString(`<body>${html}</body>`, 'text/html')
  const elements = [...document.body.querySelectorAll('*')]
  for (const element of elements) {
    if (!ALLOWED_TAGS.has(element.tagName)) {
      element.replaceWith(...element.childNodes)
      continue
    }
    for (const attribute of [...element.attributes]) {
      const name = attribute.name.toLowerCase()
      if (name.startsWith('on')) {
        element.removeAttribute(attribute.name)
        continue
      }
      if (name === 'style') {
        const safe = attribute.value.split(';').map(rule => rule.trim()).filter(rule => {
          const property = rule.split(':', 1)[0]?.trim().toLowerCase()
          return ALLOWED_STYLES.has(property)
        }).join(';')
        if (safe) element.setAttribute('style', safe)
        else element.removeAttribute('style')
        continue
      }
      if (element.tagName === 'A' && ['href', 'target', 'rel'].includes(name)) {
        if (name === 'href' && !/^(https?:|mailto:|#)/i.test(attribute.value)) element.removeAttribute('href')
        continue
      }
      if (element.tagName === 'IMG' && ['src', 'alt', 'title', 'loading'].includes(name)) {
        if (name === 'src' && !/^(https?:\/\/|data:image\/(?:png|jpe?g|webp);base64,)/i.test(attribute.value)) {
          element.removeAttribute('src')
        }
        continue
      }
      if (element.tagName === 'OL' && name === 'start') continue
      if (element.tagName === 'MARK' && name === 'data-color') continue
      // LaTeX 公式节点：保留 data-latex / data-type（渲染端用 KaTeX 转换）
      if ((element.tagName === 'SPAN' || element.tagName === 'DIV') && ['data-latex', 'data-type'].includes(name)) continue
      element.removeAttribute(attribute.name)
    }
    if (element.tagName === 'A') {
      element.setAttribute('rel', 'noopener noreferrer')
      element.setAttribute('target', '_blank')
    }
    if (element.tagName === 'IMG') {
      if (!element.getAttribute('src')) element.remove()
      else {
        element.setAttribute('loading', 'lazy')
        if (!element.getAttribute('alt')) element.setAttribute('alt', '闪念插图')
      }
    }
  }
  return document.body.innerHTML
}
